import React from "react";
import CartTabs from "./Cart/CartTabs";
import WishList from "./Cart/WishList/WishList";

class SaleOrderAjaxWishList extends React.Component {
    render() {
        const {basketItems, wishList} = this.props;

        return (
            <div className="cart">

                <CartTabs
                    activeButton={"wishList"}
                    cart={basketItems.length}
                    wishList={wishList.length}
                />

                <WishList
                    items={wishList}
                    _onRemoveItem={id => this.props._onRemoveWishListItem(id)}
                    _onMoveToBasket={id => this.props._onMoveToBasket(id)}
                />

            </div>
        );
    }
}

export default SaleOrderAjaxWishList;